import React from 'react';
import { Card } from '../../ui/card';
import { Button } from '../../ui/button';
import { Edit, Trash2, ExternalLink } from 'lucide-react';

export const ArtistCard = ({ artist, onEdit, onDelete }) => (
  <Card className="bg-black/50 border-green-500/30 hover:border-green-500 hover:shadow-xl hover:shadow-green-500/30 hover:-translate-y-1 overflow-hidden group p-0 transition-all duration-300">
    <div className="relative aspect-square overflow-hidden">
      <img src={artist.image} alt={artist.name} className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" />
    </div>
    <div className="p-4 pb-6">
      <h3 className="text-lg font-bold text-white mb-1">{artist.name}</h3>
      <p className="text-gray-400 text-sm line-clamp-2 mb-4">{artist.bio}</p>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" onClick={onEdit} className="flex-1 border-green-500/30 hover:bg-green-500/20">
          <Edit className="w-4 h-4 mr-1" /> Edit
        </Button>
        <Button size="sm" variant="outline" onClick={onDelete} className="flex-1 border-red-500/30 hover:bg-red-500/20 text-red-400">
          <Trash2 className="w-4 h-4 mr-1" /> Delete
        </Button>
        {artist.soundcloudUrl && (
          <Button size="sm" variant="outline" onClick={() => window.open(artist.soundcloudUrl, '_blank')} className="border-orange-500/30 hover:bg-orange-500/20">
            <ExternalLink className="w-4 h-4" />
          </Button>
        )}
      </div>
    </div>
  </Card>
);
